import React from 'react';
import { View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { reviewDesk } from '@/design-system';
import { profileWebStyles } from '../profileStyles';

interface UsageMeterProps {
  label: string;
  value: string;
  /** 0-100 */
  percent: number;
  icon: keyof typeof MaterialIcons.glyphMap;
  color?: string;
  testID?: string;
}

export function UsageMeter({ label, value, percent, icon, color = reviewDesk.accent, testID }: UsageMeterProps) {
  return (
    <View testID={testID} style={profileWebStyles.usageMeter}>
      <View style={profileWebStyles.usageMeterTop}>
        <View style={[profileWebStyles.usageIcon, { backgroundColor: `${color}16` }]}>
          <MaterialIcons name={icon} size={20} color={color} />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={profileWebStyles.usageLabel}>{label}</Text>
          <Text style={profileWebStyles.usageValue}>{value}</Text>
        </View>
      </View>
      <View style={profileWebStyles.progressTrack}>
        <View style={[profileWebStyles.progressFill, { width: `${percent}%`, backgroundColor: color }]} />
      </View>
    </View>
  );
}
